import { useEffect, useRef, useState } from "react";
import Head from "next/head";
import { safeNext } from "../src/lib/access";
import { edition } from "../src/lib/extensions/registry";
import styles from "../src/components/welcome/welcome.module.css";

// The welcome page, while the site is closed (see middleware.js): the question, a picture
// (public/assets/welcome/daffy.png, hidden until it's there), and the password box. A wrong password
// turns the box red (and says so to screen readers); the right one goes on to the page you asked for
// (`next`). `wrong` is when the form, without scripts, was sent back here.
export function getServerSideProps({ query }) {
  return { props: { next: safeNext(query.next), wrong: Boolean(query.wrong) } };
}
export default function Welcome({ next, wrong }) {
  const [password, setPassword] = useState(""), [missed, setMissed] = useState(wrong ? 1 : 0), [busy, setBusy] = useState(false), [picture, setPicture] = useState(true);
  // (It may have failed before the page's script was running to hear it.)
  const image = useRef(null);
  useEffect(() => { if (image.current?.complete && !image.current.naturalWidth) setPicture(false); }, []);

  async function enter(event) {
    event.preventDefault();
    setBusy(true);
    try {
      const response = await fetch("/api/access", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ password, next }) });
      if (response.ok) { window.location.assign((await response.json()).next); return; }
    } catch { /* As a wrong one: try again. */ }
    setMissed((count) => count + 1); setPassword(""); setBusy(false);
  }

  return <main className={styles.page}>
    <Head>
      <title>{edition().name || "TrueChops"}</title>
      <meta name="robots" content="noindex" />
    </Head>
    <form className={styles.form} method="post" action="/api/access" onSubmit={enter}>
      {edition().name && <p>{edition().name}</p>}
      <h1><label htmlFor="welcome-password">What&apos;s the password?</label></h1>
      {picture && <img ref={image} className={styles.picture} src="/assets/welcome/daffy.png" alt="Daffy Duck" onError={() => setPicture(false)} />}
      <input type="hidden" name="next" value={next} />
      <div className={styles.row}>
        <input key={missed} id="welcome-password" className={missed ? styles.missed : undefined} name="password" type="password" value={password} onChange={(event) => setPassword(event.target.value)}
          autoComplete="current-password" autoCapitalize="none" spellCheck={false} required autoFocus aria-invalid={missed > 0} />
        <button type="submit" disabled={busy}>Enter</button>
      </div>
      <p className={styles.hidden} role="status">{missed ? "That's not the password." : ""}</p>
    </form>
  </main>;
}
// No menu: everything it leads to is behind the password.
Welcome.bare = true;
